import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GiftIcon, PresentationChartLineIcon, UserCircleIcon, Cog6ToothIcon, ArrowRightIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../../context/AuthContext';
import ReuploadNotice from '../../components/ReuploadNotice';

// ✅ THIS IS THE FIX: The full JSX for the component is now included.
const DashboardCard = ({ to, icon, title, children, color }) => (
  <Link to={to} className={`block p-6 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${color}`}>
    <div className="flex items-center">
      <div className="p-3 rounded-full bg-white/20">
        {icon}
      </div>
      <h3 className="ml-4 text-xl font-bold text-white">{title}</h3>
      <ArrowRightIcon className="w-6 h-6 ml-auto text-white/50" />
    </div>
    <p className="mt-2 text-white/80">{children}</p>
  </Link>
);

export default function RecipientDashboardPage() {
  const { user } = useAuth();
  const [hasRequested, setHasRequested] = useState(false);
  
  useEffect(() => {
    const requestStatus = localStorage.getItem('requestSubmitted') === 'true';
    setHasRequested(requestStatus);
  }, []);
  
  const userName = user?.first_name || 'Recipient';

  return (
    <div className="max-w-7xl mx-auto">
      <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">Welcome, {userName}!</h1>
      <p className="mt-1 text-gray-500 dark:text-gray-400">This is your central hub. Manage your campaign and profile from here.</p>

      {/* Add the reupload notice here */}
      <ReuploadNotice />


      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {hasRequested ? (
          <DashboardCard
            to="/recipient/status"
            icon={<PresentationChartLineIcon className="w-8 h-8 text-white" />}
            title="Campaign Status"
            color="bg-gradient-to-br from-green-500 to-green-700"
          >
            Your request is pending. Click here to view the current status of your campaign.
          </DashboardCard>
        ) : (
          <DashboardCard
            to="/recipient/catalog"
            icon={<GiftIcon className="w-8 h-8 text-white" />}
            title="Start a Campaign"
            color="bg-gradient-to-br from-orange-500 to-orange-700"
          >
            You haven't requested an item yet. Browse the catalog to start your campaign.
          </DashboardCard>
        )}

        <DashboardCard
          to="/recipient/profile"
          icon={<UserCircleIcon className="w-8 h-8 text-white" />}
          title="My Profile"
          color="bg-gradient-to-br from-blue-500 to-blue-700"
        >
          View and manage the personal information and documents you've submitted.
        </DashboardCard>
        
        <DashboardCard
          to="/recipient/settings"
          icon={<Cog6ToothIcon className="w-8 h-8 text-white" />}
          title="Settings"
          color="bg-gradient-to-br from-slate-600 to-slate-800"
        >
          Manage your account settings, such as changing your password.
        </DashboardCard>
      </div>
    </div>
  );
}